import { useState } from 'react';
import { supabase } from './supabase';

export default function Auth() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isSignUp, setIsSignUp] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [message, setMessage] = useState<string | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true); setError(null); setMessage(null);
    try {
      if (isSignUp) {
        const { error } = await supabase.auth.signUp({ email, password });
        if (error) throw error;
        setMessage('Check your email to confirm your account.');
      } else {
        const { error } = await supabase.auth.signInWithPassword({ email, password });
        if (error) throw error;
      }
    } catch (err: any) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      display:'flex', alignItems:'center', justifyContent:'center',
      height:'100vh', background:'#f8f7f3'
    }}>
      <div style={{
        background:'#fff', borderRadius:12, border:'0.5px solid #d3d1c7',
        padding:'32px 28px', width:360
      }}>
        <div style={{fontSize:22,fontWeight:500,marginBottom:4}}>LandFrame</div>
        <div style={{fontSize:13,color:'#888',marginBottom:24}}>
          {isSignUp ? 'Create your account' : 'Sign in to your account'}
        </div>
        <form onSubmit={handleSubmit}>
          <input
            type="email" placeholder="Email address"
            value={email} onChange={e => setEmail(e.target.value)}
            style={{width:'100%',padding:'9px 12px',fontSize:13,
              border:'1px solid #d3d1c7',borderRadius:6,marginBottom:10,outline:'none'}}
          />
          <input
            type="password" placeholder="Password"
            value={password} onChange={e => setPassword(e.target.value)}
            style={{width:'100%',padding:'9px 12px',fontSize:13,
              border:'1px solid #d3d1c7',borderRadius:6,marginBottom:16,outline:'none'}}
          />
          {error && <div style={{color:'#c0392b',fontSize:13,marginBottom:10}}>{error}</div>}
          {message && <div style={{color:'#27500a',fontSize:13,marginBottom:10}}>{message}</div>}
          <button type="submit" disabled={loading} style={{
            width:'100%',padding:'10px',fontSize:13,fontWeight:500,
            background:'#0D9488',color:'#fff',border:'none',
            borderRadius:6,cursor:'pointer'
          }}>{loading ? 'Loading...' : isSignUp ? 'Create account' : 'Sign in'}</button>
        </form>
        <div style={{textAlign:'center',marginTop:16,fontSize:13,color:'#888'}}>
          {isSignUp ? 'Already have an account? ' : "Don't have an account? "}
          <span style={{color:'#0D9488',cursor:'pointer'}}
            onClick={() => setIsSignUp(!isSignUp)}>
            {isSignUp ? 'Sign in' : 'Sign up'}
          </span>
        </div>
      </div>
    </div>
  );
}
